import f from "./index843.js";
import n from "./index844.js";
import l from "./index845.js";
import a from "./index846.js";
import u from "./index847.js";
import s from "./index848.js";
import L from "./index849.js";
import p from "./index850.js";
var O = 1, _ = 2, v = 4, N = L(function(o, t) {
  var r = {};
  if (o == null)
    return r;
  var m = !1;
  t = f(t, function(e) {
    return e = a(e, o), m || (m = e.length > 1), e;
  }), u(o, p(o), r), m && (r = n(r, O | _ | v, s));
  for (var i = t.length; i--; )
    l(r, t[i]);
  return r;
});
export {
  N as default
};
